import { cn } from '@/utils/extra'

export default function P ({ text, className }) {
  return (
    <div className={cn('flex w-full', className?.includes('left') ? 'justify-start' : className?.includes('right') ? 'justify-end' : 'justify-center')}>
      <p
        className={cn(
          'lg:text-base text-sm text-gray-400 -mt-3 mb-3',
          className
        )}
      >
        {text}
      </p>
    </div>
  )
}
